import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Rooms from './components/Rooms';
import Experiences from './components/Experiences';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminBookings from './components/AdminBookings';

function SiteHome() {
  return (
    <LanguageProvider>
      <div className="App">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Rooms />
          <Experiences />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SiteHome />} />
        <Route path="/prenotazioni" element={<AdminBookings />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
